import React, { useState } from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';

import useViewerUpdate from '@hooks/useViewerUpdate';
import MessagesSettingsFieldsEnable, {
    messagesSettingsFieldsEnableValidationSchema,
} from '../../_molecules/MessagesSettingsFieldsEnable';
import MessagesSettingsFieldsNotifications, {
    messagesSettingsFieldsNotificationsValidationSchema,
} from '../../_molecules/MessagesSettingsFieldsNotifications';
import SubmitButton from '@atoms/SubmitButton';
import LoadingArea from '@molecules/LoadingArea';
import useViewer from '@hooks/useViewer';
import ErrorHandler from '../../_molecules/ErrorHandler';

const validationSchema = Yup.object().shape({
    ...messagesSettingsFieldsEnableValidationSchema,
    ...messagesSettingsFieldsNotificationsValidationSchema,
});

const MessagesSettingsForm = () => {
    const { loading: isLoadingViewer, viewer } = useViewer();
    const [isSuccessfulUpdate, setIsSuccessfulUpdate] = useState(false);
    const [isErrorUpdate, setIsErrorUpdate] = useState(false);
    const { updateViewer, isLoading: isLoadingUpdate } = useViewerUpdate({
        onCompleted: () => {
            setIsSuccessfulUpdate(true);
            setTimeout(() => {
                setIsSuccessfulUpdate(false);
            }, 2000);
        },
        onError: e => {
            setIsErrorUpdate(true);
            setTimeout(() => {
                setIsErrorUpdate(false);
            }, 2000);
        },
    });

    const onSubmit = values => {
        const updatedValues = {
            messages: values.messages === 'true',
            notifications: values.notifications ? values.notifications : viewer.notifications,
        };
        updateViewer({ variables: updatedValues });
    };

    const getInitialValues = () => {
        if (!viewer) return {};

        return {
            messages: viewer.messages ? viewer.messages.toString() : 'false',
            notifications: viewer.notifications ? viewer.notifications : [],
        };
    };

    if (isLoadingViewer) {
        return (
            <div className="p-4 col-md-9 px-md-7">
                <LoadingArea />
            </div>
        );
    }

    if (!viewer) return null;

    return (
        <ErrorHandler>
            <Formik onSubmit={onSubmit} initialValues={getInitialValues()} validationSchema={validationSchema}>
                {({ values, errors }) => (
                    <Form noValidate style={{ display: 'flex', flexDirection: 'column' }}>
                        <MessagesSettingsFieldsEnable values={values} />
                        <MessagesSettingsFieldsNotifications values={values} />
                        <SubmitButton
                            style={{ maxWidth: '250px' }}
                            isSubmitting={isLoadingUpdate}
                            isSuccessful={isSuccessfulUpdate}
                            isError={isErrorUpdate}
                        >
                            Save
                        </SubmitButton>
                    </Form>
                )}
            </Formik>
        </ErrorHandler>
    );
};

export default MessagesSettingsForm;
